import { render } from "./OrderWarning.vue?vue&type=template&id=33f72892&scoped=true&ts=true"
import script from "./OrderWarning.vue?vue&type=script&lang=ts"
export * from "./OrderWarning.vue?vue&type=script&lang=ts"

import "./OrderWarning.vue?vue&type=style&index=0&id=33f72892&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f72892"]])

export default __exports__